import { PageController } from '@client/components/_core/layout/PageController';
import { PaymentLibraryTab } from '@client/components/claims/financials/payment-approval/PaymentLibraryTab';
import { claimFormStore } from '@client/routes/~console.$orgId/~claims/~details.$id/store';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/claims/details/$id/financials/compensations/details/$compensationId/library',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Library',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    // CUR-725: a closed claim's financial libraries are read-only (the server rejects the writes).
    const isReadonly = claimFormStore.use.isReadonly();

    return (
        <PageController route={Route}>
            <Outlet />
            <PaymentLibraryTab compensationId={Route.useParams().compensationId} isReadonly={isReadonly} />
        </PageController>
    );
}
